import React from 'react';

const DeleteIconForOption = () => (
 <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 500 500" id="delete" width="18" height="18">
  <path fill="#e93434" d="M232.192,232.192L80.769,232.192L80.769,298.028L232.192,298.028L232.192,449.451L298.028,449.451L298.028,298.028L449.451,298.028L449.451,232.192L298.028,232.192L298.028,80.769L232.192,80.769L232.192,232.192Z" transform="rotate(45 275.794 239.316)"></path>
</svg>
);

export default DeleteIconForOption;
